import { render } from "./ThePage.vue?vue&type=template&id=32cc1a34&scoped=true"
const script = {}

import "@/assets/styles/thepage.scss?vue&type=style&index=0&id=32cc1a34&lang=scss&scoped=true"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cc1a34"]])

export default __exports__